import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import Home from "../../Home";
import DayUp from "../../DayUp";
import School from "../../School";
import SchoolDetail from "../../SchoolDetail";
import Major from "../../Major";
import MajorIntro from "../../MajorIntro";
import ArticleList from "../../ArticleList";
import ArticleDetail from "../../ArticleDetail";
import My from "../../My/Home";
import MyPw from "../../My/PwSet";
import Register from "../../User/components/Register";
import Reset from "../../User/components/Reset";
import ModifyPw from "../../User/components/ModifyPw";
import TabBar from "../../../components/TabBar";
import PowerfulQuery from "../../PowerfulQuery";
import PowerfulQueryHow from "../../PowerfulQuery/components/PowerfulQueryHow";
import SubjectQuery from "../../PowerfulQuery/components/SubjectQuery";
import SubjectQuerySchoolList from "../../SubjectQuerySchool/SchoolList";
import SubjectQuerySchoolDetail from "../../SubjectQuerySchool/SchoolDetail";
import MajorQuery from "../../PowerfulQuery/components/MajorQuery";
import MajorQuerySearch from "../../PowerfulQuery/components/MajorQuery/components/MajorQueryKeySearch";
import MajorQuerySchoolList from "../../MajorQuerySchool/SchoolList";
import SubjectRank from "../../Rank/SubjectRank";
import SubjectRankKeySearch from "../../Rank/SubjectRank/components/SubjectRankKeySearch";
import SubjectRankSubClass from "../../Rank/SubjectRank/components/SubjectRankSubClass";
import SubjectRankIntro from "../../Rank/SubjectRank/components/SubjectRankIntro";
import SchoolRank from "../../Rank/SchoolRank";
import SchoolRankIntro from "../../Rank/SchoolRank/components/SchoolRankIntro";
import SchoolRankNoStarIntro from "../../Rank/SchoolRank/components/SchoolRankNoStarIntro";
import IntelligentBigDataHome from "../../IntelligentBigData/IntelligentBigDataHome";
import IntelligentBigDataKeySearch from "../../IntelligentBigData/IntelligentBigDataKeySearch";
import Pay from "../../Pay";
import TrinityCondition from "../../Trinity/TrinityCondition";
import TrinityResult from "../../Trinity/TrinityResult";
import Login from "../../../components/Login";
import ToCollegeToolCondition from "../../ToCollegeTool/ToCollegeToolCondition";
import ToCollegeToolMajor from "../../ToCollegeTool/ToCollegeToolMajor";
import ToCollegeToolResult from "../../ToCollegeTool/ToCollegeToolResult";
import ToCollegeToolFilter from "../../ToCollegeTool/ToCollageToolFilter";
class Routes extends Component {
  render() {
    const { userUi } = this.props;
    return (
      <Router>
        <Switch>
          <Route path="/user/register" component={Register}></Route>
          <Route path="/user/reset" component={Reset}></Route>
          <Route path="/user/mpw" component={ModifyPw}></Route>
          <Route
            path="/"
            render={() => (
              <div>
                <Switch>
                  <Route path="/" exact component={Home} />
                  <Route path="/dayup" component={DayUp} />
                  <Route path="/school" component={School}></Route>
                  <Route path="/major" component={Major}></Route>
                  <Route exact path="/my" component={My}></Route>
                  <Route path="/my/pwset" component={MyPw}></Route>
                  <Route path="/majorintro/:id" component={MajorIntro}></Route>
                  <Route
                    path="/schooldetail/:hashId"
                    component={SchoolDetail}
                  ></Route>
                  <Route path="/articlelist" component={ArticleList}></Route>
                  <Route
                    path="/articledetail/:hashId"
                    component={ArticleDetail}
                  ></Route>
                  <Route
                    exact
                    path="/powerfulquery"
                    component={PowerfulQuery}
                  ></Route>
                  <Route
                    path="/powerfulquery/how"
                    component={PowerfulQueryHow}
                  ></Route>
                  <Route
                    exact
                    path="/subjectquery"
                    component={SubjectQuery}
                  ></Route>
                  <Route
                    path="/subjectquery/list"
                    component={SubjectQuerySchoolList}
                  ></Route>
                  <Route
                    path="/subjectquery/schooldetail/:hashId"
                    component={SubjectQuerySchoolDetail}
                  ></Route>
                  <Route
                    exact
                    path="/majorquery"
                    component={MajorQuery}
                  ></Route>
                  <Route
                    path="/majorquery/search"
                    component={MajorQuerySearch}
                  ></Route>
                  <Route
                    path="/majorquery/list"
                    component={MajorQuerySchoolList}
                  ></Route>
                  <Route
                    exact
                    path="/rank/subject"
                    component={SubjectRank}
                  ></Route>
                  <Route
                    path="/rank/subject/search"
                    component={SubjectRankKeySearch}
                  ></Route>
                  <Route
                    path="/rank/subject/subclass/:hashId"
                    component={SubjectRankSubClass}
                  ></Route>
                  <Route
                    path="/rank/subject/intro/:hashId"
                    component={SubjectRankIntro}
                  ></Route>
                  <Route
                    exact
                    path="/rank/school"
                    component={SchoolRank}
                  ></Route>
                  <Route
                    path="/rank/school/intro/:hashId"
                    component={SchoolRankIntro}
                  ></Route>
                  <Route
                    path="/rank/school/nostar/intro/:hashId"
                    component={SchoolRankNoStarIntro}
                  ></Route>
                  <Route
                    path="/intelligentbigdata/home"
                    component={IntelligentBigDataHome}
                  ></Route>
                  <Route
                    path="/intelligentbigdata/search"
                    component={IntelligentBigDataKeySearch}
                  ></Route>
                  <Route path="/pay" component={Pay}></Route>
                  <Route
                    path="/trinity/condition"
                    component={TrinityCondition}
                  ></Route>
                  <Route
                    path="/trinity/result"
                    component={TrinityResult}
                  ></Route>
                  <Route
                    path="/tocollege/condition"
                    component={ToCollegeToolCondition}
                  ></Route>
                  <Route
                    path="/tocollege/major"
                    component={ToCollegeToolMajor}
                  ></Route>
                  <Route
                    path="/tocollege/result"
                    component={ToCollegeToolResult}
                  ></Route>
                  <Route
                    path="/tocollege/filter"
                    component={ToCollegeToolFilter}
                  ></Route>
                </Switch>
                <TabBar></TabBar>
                <Login visible={userUi.showLogin}></Login>
              </div>
            )}
          />
        </Switch>
      </Router>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userUi: state.user.uiStateData,
  };
};

export default connect(mapStateToProps)(Routes);



// WEBPACK FOOTER //
// ./src/containers/App/Routes/index.js